( () => {

	const w = window, d = document;

	var tpdCommentsCTA = w.tpdCommentsCTA;

	var tpdCommentsCTAFunctions = {

		getCommentingElementSelector: function() {
            let possibleElement = document.querySelector( '#openweb-container-wrapper' );
            if ( ! possibleElement ) {
                return null;
            }
            possibleElement.style.scrollMarginTop = '60px';
            return '#openweb-container-wrapper';
		},

		getAnchorCTAElements: function() {
			return d.querySelectorAll( '.comments-cta-anchor' );
		},

		updateAnchorLinks: function() {

			let commentingElementSelector = tpdCommentsCTAFunctions.getCommentingElementSelector();
			if ( ! commentingElementSelector ) {
				return;
			}

			let anchorCTAElements = tpdCommentsCTAFunctions.getAnchorCTAElements();
			if ( ! anchorCTAElements.length ) {
				return;
			}

			/**
			 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
			 */
			w.tpd = w.tpd || {};
			w.tpd.scrollIntoViewOfCommentingForTpdTheme = ( e ) => {
				e.preventDefault();

				d.querySelector( commentingElementSelector ).scrollIntoView( {
					behavior: 'smooth',
					block: 'start',
				} );
			};

			anchorCTAElements.forEach( element => {
				element.addEventListener( 'click', window.tpd.scrollIntoViewOfCommentingForTpdTheme );
			} );

			/**
			 * Prevent interstitial ads from firing on clicks.
			 */
			anchorCTAElements.forEach( anchorCTAElement => {
				anchorCTAElement.setAttribute( 'data-google-interstitial', 'false' );
			} );

		},

		updateComments: function( commentCount ) {
			var elems = d.querySelectorAll( '.comments-cta-count span' );
			var index = 0, length = elems.length;
			for ( ; index < length; index++ ) {
				elems[ index ].innerHTML = commentCount;
			}
		},

		spotimApiFetchUrl: function() {
			let spotimId = tpdCommentsCTA.spot_id;
			let postId 	 = tpdCommentsCTA.post_id;
			return `https://open-api.spot.im/v1/messages-count?spot_id=${ spotimId }&posts_ids=${ postId }`;
		},

		getCommentCount: function() {

			// Return if type is not defined.
			if ( ! tpdCommentsCTA ) {
				return;
			}

			var commentCount = 0;

            fetch( tpdCommentsCTAFunctions.spotimApiFetchUrl() )
            .then( ( response ) => {
                if ( response.status === 200 ) {
                    return response.json();
                } else {
                    throw `comments cta disqus error with status ${response.status}`;
                }
            } )
            .then( ( data ) => {
                commentCount = data.messages_count[ tpdCommentsCTA.post_id ];
                tpdCommentsCTAFunctions.updateComments( commentCount );
            } );

			tpdCommentsCTAFunctions.updateAnchorLinks();

		}
	};

	tpdCommentsCTAFunctions.getCommentCount();

} )();
